/**
 * What a resource card calls its file type.
 *
 * The raw MIME subtype used to be uppercased straight onto the card, which
 * is "PDF" and "PLAIN" for the simple kinds and
 * "VND.OPENXMLFORMATS-OFFICE..." for every Office file. The label is the
 * one word the list needs; the bounds are `isValidResource`'s eight types.
 */
const RESOURCE_TYPE_LABELS: Record<string, string> = {
  "application/pdf": "PDF",
  "application/msword": "Word",
  "application/vnd.ms-excel": "Excel",
  "application/vnd.ms-powerpoint": "PowerPoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "Word",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    "PowerPoint",
  "text/plain": "Text",
};

export function resourceTypeLabel(
  contentType: string | undefined,
): string | null {
  if (!contentType) return null;
  return RESOURCE_TYPE_LABELS[contentType] ?? null;
}
